import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import Hero from './Hero';
import NavbarStandard from './NavbarStandard';
import Partners from './Partners';
import Processes from './Processes';
import Services from './Services';
import Testimonial from './Testimonial';
import Cta from './Cta';
import FooterStandard from './FooterStandard';
import { getConfig } from 'y4/Falcon';
import { version } from 'config';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

const Landing = () => {
  const [configs, setConfigs] = useState([]);
  const { t } = useTranslation();
  useEffect(() => {
    getConfig('Landing', 'asc').then(cs => {
      /**
{
  "key": "LandingProcess",
  "code": "编码",
  "title": "标题",
  "caption": "说明",
  "url": "连接",
  "imageUrl": null,
  "videoUrl": null,
  "content": "数据",
  "extension": null,
  "date": "12/13/2024 15:24:33",
  "remark": null
}
       */

      if (!_.isEmpty(cs)) setConfigs(cs);
    });
  }, []);

  return (
    <>
      <NavbarStandard />
      <Hero configs={configs.filter(f => _.startsWith(f.key, 'LandingHero'))} />
      <Partners
        configs={configs.filter(f => _.startsWith(f.key, 'LandingPartner'))}
      />
      <Processes
        configs={configs.filter(f => _.startsWith(f.key, 'LandingProcess'))}
      />
      <Services
        configs={configs.filter(f => _.startsWith(f.key, 'LandingService'))}
      />
      <Testimonial
        configs={configs.filter(f => _.startsWith(f.key, 'LandingTestimonial'))}
      />
      <Cta configs={configs.filter(f => _.startsWith(f.key, 'LandingCta'))} />
      <FooterStandard
        configs={configs.filter(f => _.startsWith(f.key, 'LandingFooter'))}
      />
      <section className=" bg-dark py-0 text-center fs--1 light">
        <hr className="my-0 border-600 opacity-25" />
        <div className="container py-3">
          <Row className="justify-content-between">
            <Col xs={12} sm="auto">
              <p
                className="mb-0 text-600"
                dangerouslySetInnerHTML={{
                  __html: t('Thank you for selected AllyWorld')
                }}
              ></p>
            </Col>
            <Col xs={12} sm="auto">
              <p className="mb-0 text-600">v{version}</p>
            </Col>
          </Row>
        </div>
      </section>
    </>
  );
};

export default Landing;
